import { useCallback, useMemo } from 'react'
import { ByWeekday, RRule, Weekday } from '@guestgoodie/helpers'

import Dropdown from '@/components/ui/Dropdown'
import { WeekOption } from '../types'
import { useDayOptions, useWeekOptions } from '../utils/helpers'

export function NthWeekdaySelect({
  value,
  onChange
}: {
  value?: ByWeekday | ByWeekday[] | null
  onChange: (value: Weekday[]) => void
}) {
  const weekOptions = useWeekOptions()
  const dayOptions = useDayOptions()

  const currentValue = useMemo(() => {
    if (!value) return RRule.MO.nth(1)
    return Array.isArray(value) ? value[0] : value
  }, [value])

  const parsedValue = useMemo(() => {
    if (typeof currentValue === 'number') {
      return new Weekday(currentValue)
    }

    if (typeof currentValue === 'string') {
      return Weekday.fromStr(currentValue)
    }

    return currentValue
  }, [currentValue])

  const weekday = useMemo(() => parsedValue.weekday, [parsedValue])
  const week = useMemo(() => parsedValue.n ?? 1, [parsedValue])

  const onChangeWeek = useCallback(
    (week: WeekOption) => {
      const newValue = parsedValue.nth(week)

      onChange([newValue])
    },
    [parsedValue, onChange]
  )

  const onChangeWeekday = useCallback(
    (day: number) => {
      const newValue = new Weekday(day, week)

      onChange([newValue])
    },
    [week, onChange]
  )

  return (
    <label className="flex flex-row gap-2 items-center">
      <Dropdown<WeekOption>
        options={weekOptions}
        value={week}
        onChange={onChangeWeek}
      />
      <Dropdown
        options={dayOptions}
        value={weekday}
        onChange={onChangeWeekday}
      />
    </label>
  )
}
